import styled, { css } from 'styled-components';
import { Box } from '@chakra-ui/react';

export const StyledBox = styled(Box)`
    @media (min-width: 979px) {
        &:not(:last-child) {
            border-right: 1px solid #c8c8c8;
        }
    }
`;
